import { useIntl } from 'react-intl';

import { Sport } from '#src/__generated__/globalTypes.ts';
import { ArenaIcon } from '#src/atoms/icons/ArenaIcon.tsx';
import { ProModeIcon } from '#src/atoms/icons/ProModeIcon.tsx';
import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconList } from '#src/atoms/icons/system/iconList.ts';
import {
  ANY_SPORT_LINEUPS,
  ANY_SPORT_LINEUPS_ARENA,
  ANY_SPORT_LINEUPS_PRO,
} from '#src/constants/__generated__/routes.ts';
import { useConfigContext } from '#src/contexts/config/index.ts';
import { useSeriesNav } from '#src/hooks/commonGame/useSeriesNav.ts';
import { useEnableProMode } from '#src/hooks/useEnableProMode.ts';
import { useEnableSorare27Nav } from '#src/hooks/useEnableSorare27Nav.ts';
import { navLabels } from '#src/lib/glossary.ts';
import { generateSportPath } from '#src/lib/routing/generateSportPath.ts';

import { NavItemWithSubNav } from '../NavItemWithSubNav/index.tsx';
import { useNavItemLayout } from '../useNavItemLayout.ts';

type Props = { sport: Sport; sidebarCollapsed?: boolean };

export const LineupsNavItem = ({ sport, sidebarCollapsed }: Props) => {
  const { formatMessage } = useIntl();
  const { navItemsVariant } = useNavItemLayout();
  const seriesNav = useSeriesNav();
  const isSorare27Nav = useEnableSorare27Nav();
  const { so5 } = useConfigContext();
  const enableProMode = useEnableProMode(sport);

  if (seriesNav || !isSorare27Nav) {
    return null;
  }

  const showLiveDot = so5?.currentManagerHasLiveGames;

  return (
    <NavItemWithSubNav
      item={{
        variant: navItemsVariant,
        icon: () => <FontAwesomeIcon icon={iconList} size="1x" />,
        label: 'Lineups',
        to: generateSportPath(
          enableProMode ? ANY_SPORT_LINEUPS : ANY_SPORT_LINEUPS_ARENA,
          { sport }
        ),
        sidebarCollapsed,
        enableContextModeNavigation: true,
        enabledStoredLastNavigation: true,
        showLiveDot: !seriesNav && sport !== Sport.NBA && showLiveDot,
        subItems: enableProMode
          ? [
              {
                icon: () => <ProModeIcon size={2} />,
                label: formatMessage(navLabels.pro),
                to: generateSportPath(ANY_SPORT_LINEUPS_PRO, { sport }),
              },
              {
                icon: () => <ArenaIcon size={2} />,
                label: formatMessage(navLabels.arena),
                to: generateSportPath(ANY_SPORT_LINEUPS_ARENA, { sport }),
              },
            ]
          : [],
      }}
    />
  );
};
